import { Alert, AlertTitle, Button, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GenericDialog } from 'src/shared/components/organisms/genericDialog';

type MemberActivateMemberNotAuthorizedModalProps = {
  modalOpen: boolean;
  onClose: () => void;
};

export const MemberActivateMemberNotAuthorizedModal = (props: MemberActivateMemberNotAuthorizedModalProps) => {
  const { modalOpen, onClose } = props;
  const { t } = useTranslation();

  return (
    <GenericDialog
      open={modalOpen}
      onClose={onClose}
      onSave={onClose}
      maxWidth='xs'
      showDialogActions
      padding={0}
      dialogTitle={t('member:enterMember.activateMembership')}
      dialogContent={
        <Grid container>
          <Grid item xs={12}>
            <Alert severity='error'>
              <AlertTitle>{t('member:enterMember.memberWithInvoicesTitle')}</AlertTitle>
              {t('member:enterMember.memberWithInvoicesDescription')}
            </Alert>
          </Grid>
        </Grid>
      }
      dialogActions={
        <Button autoFocus variant='contained' color='primary' disableElevation onClick={onClose}>
          {t('common:button.ok')}
        </Button>
      }
    />
  );
};
